import React, { useState } from 'react';
import { Wrapped } from 'components/Layouts';

import { ToggleButton } from 'components/shared/Buttons';

import { CompanyForm, Table } from 'components/Company';

export default function CompanyIndex(props) {
  const [isOpen, setOpen] = useState(false);

  return (
    <Wrapped
      title="Companies"
      button={
        <ToggleButton
          closedText="Add Company"
          onClick={() => setOpen(!isOpen)}
          open={isOpen}
        />
      }
    >
      {isOpen ? (
        <CompanyForm
          onSubmit={() => setOpen(false)}
          onClose={() => setOpen(false)}
          showCancel
          create
        />
      ) : (
        <Table />
      )}
    </Wrapped>
  );
}
